<script>
  import { Bar } from 'vue-chartjs'
  export default {
    name: 'BarChart',
    extends: Bar,
    props: {
      datasets: Array,
      labels: Array,
      options: Object,
    },
    data () {
      return {
        chartData: {
          labels: [],
          datasets: [],
        },
        chartOptions: {},
      }
    },
    watch: {
      datasets (val) {
        this.chartData.datasets = val
      },
    },
    created () {
      this.chartData.labels = this.labels
      this.chartData.options = this.options
      this.chartData.datasets = this.datasets
      this.charOptions = this.options
    },
    methods: {
      render () {
        this.$nextTick(() => { this.renderChart(this.chartData, this.options) })
      },
    },
  }
</script>
